import Backbone from 'backbone';
import { directFlights } from './directFlights';
import { block } from './block';

export default (tourCriteria: Backbone.Model): Object => ({
        ...directFlights(tourCriteria),
        ...block(tourCriteria),
});